export default __webpack_public_path__ + "static/media/FeaturePic.a0453867.png";